import { createSelector } from 'reselect';
import { v4 as uuidv4 } from 'uuid';
import {
  data as dataSelector,
  data2 as data2Selector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY, CHILDREN_CRUD_OVERVIEW } from '../PersonalInfoWorkflowConstants';

export default createSelector(dataSelector, data =>
  (data(`${BACKEND_KEY}.Dependents`) || []).map((child) => {
    if (child.frontEndId) {
      return child;
    }
    return {
      ...child,
      frontEndId: uuidv4(),
    };
  }));

export const isEmptyStateSelector = createSelector(
  dataSelector,
  data => (data(`${BACKEND_KEY}.Dependents`) || []).length <= 0,
);

export const viewIDSelector = createSelector(
  data2Selector,
  data2 => data2(`${BACKEND_KEY}.ChildrenStepViewID`) || CHILDREN_CRUD_OVERVIEW,
);
